import { Action, RuntimeFilterOp } from '@thoughtspot/visual-embed-sdk';
import { CURRENT_VALUE_TOOLTIP_KEYWORDS, VALUE_TOOLTIP_KEYWORDS } from './consts';

export const filterByMarket = (
  marketId: string,
): {
  columnName: string;
  operator: RuntimeFilterOp;
  values: string[];
} => {
  return {
    columnName: 'Market',
    operator: RuntimeFilterOp.EQ,
    values: [marketId],
  };
};

export const filterByCampaignOwner = (
  marketId: string,
): {
  columnName: string;
  operator: RuntimeFilterOp;
  values: string[];
} => {
  return {
    columnName: 'Campaign Owner',
    operator: RuntimeFilterOp.EQ,
    values: [marketId],
  };
};

export const filterByAssetOwner = (
  marketId: string,
): {
  columnName: string;
  operator: RuntimeFilterOp;
  values: string[];
} => {
  return {
    columnName: 'Asset Owner ID',
    operator: RuntimeFilterOp.EQ,
    values: [marketId],
  };
};

export const filterByDealId = (
  marketId: string,
): {
  columnName: string;
  operator: RuntimeFilterOp;
  values: string[];
} => {
  return {
    columnName: 'Deal Line ID',
    operator: RuntimeFilterOp.EQ,
    values: [marketId],
  };
};

export const filterByCampaignId = (
  marketId: string,
): {
  columnName: string;
  operator: RuntimeFilterOp;
  values: string[];
} => {
  return {
    columnName: 'Campaign ID',
    operator: RuntimeFilterOp.EQ,
    values: [marketId],
  };
};

export const labsReportVisibleActions = [
  Action.DownloadAsXlsx,
  Action.Download,
  Action.DownloadAsCsv,
  Action.CopyToClipboard,
  Action.ShowUnderlyingData,
  Action.Explore,
  Action.AxisMenuFilter,
  Action.CrossFilter,
  Action.DrillDown,
  Action.CreateMonitor,
  Action.PersonalisedViewsDropdown,
  Action.ManageMonitor,
  Action.EnableContextualChangeAnalysis,
  Action.Schedule,
  Action.AxisMenuRemove,
  Action.AxisMenuTimeBucket,
  Action.SchedulesList,
  Action.SendTestScheduleEmail,
];

export const assetHealthVisibleActions = [
  Action.DownloadAsXlsx,
  Action.Download,
  Action.DownloadAsCsv,
  Action.CopyToClipboard,
  Action.ShowUnderlyingData,
  Action.AxisMenuFilter,
  Action.CrossFilter,
  Action.DrillDown,
  Action.CreateMonitor,
  Action.PersonalisedViewsDropdown,
  Action.ManageMonitor,
  Action.EnableContextualChangeAnalysis,
  Action.Schedule,
  Action.AxisMenuRemove,
  Action.AxisMenuTimeBucket,
  Action.SchedulesList,
  Action.SendTestScheduleEmail,
];

export const generateActiveValueChipStyles = (): Record<string, Record<string, string>> => {
  const valueTargetingString = VALUE_TOOLTIP_KEYWORDS.map((keyword) => `[data-tooltip-content*='${keyword}']`).join(
    ', ',
  );
  const currentValueTargetingString = CURRENT_VALUE_TOOLTIP_KEYWORDS.map(
    (keyword) => `[data-tooltip-content*='${keyword}']`,
  ).join(', ');

  return {
    [`.chip-base-module__filter:is(${valueTargetingString}, ${currentValueTargetingString})`]: {
      'background-color': '#15115e !important',
      color: '#ffffff !important',
    },
    [`.chip-base-module__filter:is(${valueTargetingString}, ${currentValueTargetingString}):hover`]: {
      'background-color': '#272199 !important',
      color: '#ffffff !important',
    },
    [`.chip-base-module__filter:hover:not(${valueTargetingString}, ${currentValueTargetingString})`]: {
      'background-color': '#2c24c31a !important',
      color: '#000000 !important',
    },
    [`.chip-base-module__filter:is(${valueTargetingString}, ${currentValueTargetingString}) span`]: {
      'background-color': '#15115e !important',
      color: '#ffffff !important',
    },
    [`.chip-base-module__filter:is(${valueTargetingString}, ${currentValueTargetingString}):hover span`]: {
      'background-color': '#272199 !important',
      color: '#ffffff !important',
    },
    [`.chip-base-module__filter:hover:not(${valueTargetingString}, ${currentValueTargetingString}) span`]: {
      'background-color': '#2c24c31a !important',
      color: '#000000 !important',
    },
  };
};

export const thoughtspotLiveboardStyles = {
  style: {
    customCSS: {
      rules_UNSTABLE: {
        "[data-tooltip-content*='Market']": {
          display: 'none',
        },
        "[data-tooltip-content*='Deal Owner']": {
          display: 'none',
        },
        "[data-tooltip-content*='Campaign Owner']": {
          display: 'none',
        },
        '.pin-button-module__dualIntentPinButton': {
          width: '0',
          visibility: 'hidden',
        },
        '.first-pin-module__pinButton': {
          width: '0',
          visibility: 'hidden',
        },
        '.chip-base-module__filter:focus': {
          'background-color': '#15115e !important',
          color: '#ffffff !important',
        },
        ...generateActiveValueChipStyles(),
      },
    },
  },
};

export const hiddenAssetOwnerThoughtspotLiveboardStyles = {
  style: {
    customCSS: {
      rules_UNSTABLE: {
        "[data-tooltip-content*='Asset Owner ID']": {
          display: 'none',
        },
        '.pin-button-module__dualIntentPinButton': {
          width: '0',
          visibility: 'hidden',
        },
        '.first-pin-module__pinButton': {
          width: '0',
          visibility: 'hidden',
        },
        '.chip-base-module__filter:focus': {
          'background-color': '#15115e !important',
          color: '#ffffff !important',
        },
        ...generateActiveValueChipStyles(),
      },
    },
  },
};

export const TABS_STYLES = 'pt-4 h-[90%] flex';
